import { Box, Dialog, DialogContent, Grid, useMediaQuery } from "@mui/material";
import BGImage from "assets/CorporateUser";
import { ReactComponent as HiltonLogo } from "assets/HiltonBoostLogoIntercept.svg";
import Button from "components/common/Button";
import Typography from "components/common/Typography";
import { theme } from "styles/Theme";
import { tokens } from "styles/Tokens";

interface Props {
  type: "restrictRegions" | "allowedRegions";
  title: string;
  description: string;
  handleOnClick?: any;
}

function RegionInterceptPage(props: Props) {
  const { type, title, description, handleOnClick } = props;
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  const getAllowedRegionView = () => {
    if (type === "allowedRegions") {
      return (
        <Box
          width={"100%"}
          display={"flex"}
          textTransform={"none"}
          flexDirection={isMobileScreen ? "column" : "row"}
          gap={"15px"}
          marginTop={isMobileScreen ? "16px" : ""}
        >
          <Box sx={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
            <Button
              sx={{
                backgroundColor: tokens.Background.General.Primary,
                width: isMobileScreen ? "100%" : "25%",
                borderRadius: "200px",
                color: tokens.Text.General.Color,
                textTransform: "none",
                fontWeight: "600",
                "&:hover": {
                  border: `1px solid ${tokens.Border.General.Inverse}`,
                  color: tokens.Border.General.Inverse
                }
              }}
              height={isMobileScreen ? "50px" : "40px"}
              variant="primaryWhite"
              label={"Go to BOOST"}
              onClick={() => handleOnClick("Boost")}
            ></Button>
            <Typography
              variant="label"
              changeVariant={false}
              sx={{ fontSize: isMobileScreen ? "inherit" : "10px", marginTop: "2px" }}
            >
              Americas and EMEA hotels
            </Typography>
          </Box>
          <Box sx={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
            <Button
              sx={{
                backgroundColor: "transparent",
                border: `1px solid ${tokens.Border.General.Inverse}`,
                width: isMobileScreen ? "100%" : "25%",
                borderRadius: "200px",
                color: tokens.Border.General.Inverse,
                textTransform: "none",
                fontWeight: "600",
                "&:hover": {
                  backgroundColor: tokens.Background.General.Primary,
                  color: tokens.Text.General.Color
                }
              }}
              height={isMobileScreen ? "50px" : "40px"}
              variant="primaryWhite"
              label={"Go to GEN"}
              onClick={() => handleOnClick("Gen")}
            ></Button>
            <Typography
              variant="label"
              changeVariant={false}
              sx={{ fontSize: isMobileScreen ? "inherit" : "10px", marginTop: "2px" }}
            >
              APAC hotels
            </Typography>
          </Box>
        </Box>
      );
    } else {
      return <Box></Box>;
    }
  };

  return (
    <Dialog fullWidth={true} fullScreen={isMobileScreen} maxWidth={"md"} open={true}>
      <DialogContent
        sx={{
          display: "flex",
          backgroundColor: tokens.Background.General.LightColor,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100%",
          color: tokens.Text.General.Inverse,
          padding: isMobileScreen ? "8px" : "inherit"
        }}
      >
        <Grid
          container
          display={"flex"}
          flexDirection={"column"}
          sx={{
            paddingX: isMobileScreen ? "0px" : "20px",
            paddingTop: isMobileScreen ? "10px" : "20px",
            alignItems: isMobileScreen ? "center" : "none",
            textAlign: isMobileScreen ? "center" : "none",
            justifyContent: isMobileScreen ? "flex-start" : "none"
          }}
        >
          <HiltonLogo />
          <Grid item md={5} marginTop={"15%"} display={"flex"} flexDirection={"column"} gap={"20px"}>
            <Typography variant={"h4"} showBold children={title}></Typography>
            <Typography variant={"body1"} children={description}></Typography>
            {!isMobileScreen && getAllowedRegionView()}
          </Grid>
          {isMobileScreen && getAllowedRegionView()}

          {!isMobileScreen && (
            <Grid item md={6} marginTop="32px" justifyContent="flex-end">
              <BGImage />
            </Grid>
          )}
          {isMobileScreen && type === "restrictRegions" && (
            <Grid item marginTop="auto">
              <BGImage width="327px" height="371px" />
            </Grid>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default RegionInterceptPage;
